import { Button } from '@mui/material';

import groupImg from 'assets/images/group-2.jpg';
import stageClipLogo from 'assets/images/stage-clip-logo.png';
import { useLocale } from 'hooks/useLocale/useLocale';
import { Card, Typography } from 'ui/atoms';

import { useStyles } from './RaiseTicket.style';

export const RaiseTicket = () => {
  const styles = useStyles();
  const { formatMessage } = useLocale();

  return (
    <div className={styles.root}>
      <div className={styles.cardContainer}>
        <div className={styles.stageClipLogo}>
          <img src={stageClipLogo} alt="Logo" />
        </div>
        <div className={styles.content}>Find My Clip</div>
        <Card className={styles.card}>
          <Typography className={styles.emailTitle}>{formatMessage({ id: 'clip.raise.ticket.title' })}</Typography>

          <Typography className={styles.emailDescription}>
            {formatMessage({ id: 'clip.raise.ticket.description' })}
          </Typography>
          <div>
            <Button className={styles.button} href="https://stageclip.com/student-support/" target="_blank">
              {formatMessage({ id: 'raise.ticket.check.button' })}
            </Button>
          </div>
        </Card>
      </div>

      <div className={styles.institutionContainer}>
        <Typography className={styles.clientText}>{formatMessage({ id: 'find.clips.institutions.title' })}</Typography>
        <div className={styles.imageContainer}>
          <img src={groupImg} alt="HeaderImage" className={styles.images} />
        </div>
      </div>
    </div>
  );
};
